import { createContext } from "react";

export const QuestionsContext = createContext({});
